import React, { useCallback, useEffect, useMemo, useState,useRef, useContext } from 'react';
import styled from 'styled-components';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import Spacer from '../../components/Spacer';  
// import useBasisCash from '../../hooks/useBasisCash';

import { Button, Modal} from 'antd'
import moment from 'moment'
import Notice from '../../components/Notice';
// import useArticles,{ fetchArticles, useTokenInfo } from '../../hooks/useArticles';
// import { Question } from './components/Question'
import InfiniteScroll from 'react-infinite-scroller';
import _, { filter } from 'lodash'
// import { Article } from './components/Article';
import { reaction } from 'mobx';
import HomeContent from './HomeContent'
import { useHistory} from 'react-router-dom'
import { useStore } from '../../state/use-store';
// import useWaterMark from '../../hooks/useWaterMark'
import useDelayShow from '../../hooks/useDelayShow';
import { isDarkMode } from '../../utils/util';

const Home: React.FC = () => { 
  return <HomeContent/>
};
 

export default Home;
